/**
 * Agent-spine (ADR-003, governance repo): a versioned journey/skill definition
 * pushed by producer clients (evo-re-skill canvas save). Field names mirror the
 * ingest payload contract inherited from FrankenKit so producers cut over with
 * only a base-URL swap.
 */
export const journeyDefinitionDescriptor = {
    slug: 'journey_definition',
    kind: 'document',
    label: { singular: 'Percorso', plural: 'Percorsi' },
    table: 'ai_portal_journey_definition',
    idStrategy: 'sha256',
    fields: [
        { name: 'journey_id', type: 'text', label: 'ID percorso', required: true, unique: true },
        { name: 'title', type: 'text', label: 'Titolo', required: true },
        { name: 'description', type: 'text', label: 'Descrizione' },
        { name: 'pipeline_name', type: 'text', label: 'Pipeline' },
        { name: 'skills', type: 'json', label: 'Skill usate' },
        { name: 'source_repo', type: 'text', label: 'Repository di origine' },
        { name: 'tags', type: 'json', label: 'Etichette' },
        { name: 'scope', type: 'text', label: 'Ambito' },
        { name: 'status', type: 'text', label: 'Stato' },
    ],
    behaviors: {
        audit: true,
        tenantScoped: true,
    },
    emits: ['journey_definition.pushed'],
    ui: { mode: 'generated', icon: 'PartitionOutlined', navGroup: 'Agenti', navOrder: 40 },
};
